<template>
  <ECard
    v-if="camerasExids.length"
    v-resize-observer="onResize"
    class="e-h-full e-w-full"
    title="Zoho Desk Tickets"
  >
    <template #title>
      <div
        class="e-flex e-items-center e-relative pl-2"
        :class="dialog ? 'e-justify-start' : 'e-justify-center'"
      >
        <span class="e-text-sm">Zoho Desk Tickets</span>
        <div class="e-absolute e-right-4">
          <ButtonTooltip
            v-if="!dialog"
            icon
            color="primary"
            tooltip-text="Expand"
            icon-name="fas fa-expand-arrows-alt"
            :tooltip-props="{ 'nudge-bottom': 10 }"
            @click="$emit('update:dialog', true)"
          />
          <v-btn
            v-else
            icon
            class="large-icon"
            @click="$emit('update:dialog', false)"
          >
            <v-icon color="primary">fas fa-times</v-icon>
          </v-btn>
        </div>
      </div>
    </template>
    <ZohoDeskTicketsTable :cameras-exids="camerasExids" :height="height" />
  </ECard>
</template>

<script>
import ZohoDeskTicketsTable from "@/components/zohoDesk/ZohoDeskTicketsTable.vue"
import { mapStores } from "pinia"
import { useKitSummaryStore } from "@/stores/kitSummary"
import ButtonTooltip from "@evercam/shared/components/ButtonTooltip.vue"

export default {
  name: "KitZohoDeskTicketsCard",
  components: { ZohoDeskTicketsTable, ButtonTooltip },
  props: {
    dialog: {
      type: Boolean,
      value: false,
    },
  },
  data() {
    return {
      height: undefined,
    }
  },
  computed: {
    ...mapStores(useKitSummaryStore),
    camerasExids() {
      return this.kitSummaryStore.cameras?.map((c) => c.exid) || []
    },
  },
  methods: {
    onResize({ contentRect }) {
      this.height = contentRect.height - 55
    },
  },
}
</script>
